// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"9edc5c4c","489":"a1823e3b","731":"2eb956f1","894":"0a8ab438","946":"b701b58c"}[chunkId] + ".chunk.css";
};